import { useFeatureFlag } from '../feature-flags/hooks/use-feature-flag.hook';
import { FeatureFlagName } from '../feature-flags/models/feature-flag-names.enum';
import type { User } from './model/user.interface';

export interface DisplayIdentity {
  name: string;
  imageUrl?: string;
  /** true when the name and avatar come from the official author the user is linked to */
  official: boolean;
}

/**
 * The name and avatar to show for a community user. A user linked to one of the account's official
 * authors is shown as that author — its name and its artwork, not the fan profile — the same way the
 * post byline already is. Rides the community-official-authors flag like the badge.
 */
export const useDisplayIdentity = (user: User | null | undefined): DisplayIdentity => {
  const enabled = useFeatureFlag(FeatureFlagName.COMMUNITY_OFFICIAL_AUTHORS);
  const author = enabled ? user?.officialAuthor : undefined;
  if (author?.name) {
    return { name: author.name, imageUrl: author.imageUrl, official: true };
  }
  return { name: user?.username || 'anonymous', imageUrl: user?.imageUrl, official: false };
};
